import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-donut-event-split',
  templateUrl: './donut-event-split.component.html',
  styleUrl: './donut-event-split.component.scss',
})
export class DonutEventSplitComponent {
  isLoading = true;
  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.donutEventSplit$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('donutEventSplit');
    });

    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getDonutEventSplit().subscribe();
  }

  get series() {
    return this.analyticsService.donutEventSplit$.value?.series[0];
  }

  get labels() {
    return this.analyticsService.donutEventSplit$.value?.labels;
  }
}
